var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cell-renderer-chip',{attrs:{"options":_vm.chipOptions,"selected-option":_vm.params.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }